// Phase C.7 — a small lookup, not a shared conversion. Each elapsed-time
// sprint test has its own distance-specific formula (fortyYardSpeed.js /
// flyTenSpeed.js) — 40-yard and Fly 10 must never share one constant.
// This is the single place both AttemptInputGroup.js and DrillHistory.js
// ask "does this test type have a derived-at-display speed, and what is
// it for this raw time?" instead of each hardcoding its own
// `key === 'forty_yard'` special case (the exact duplication this phase
// avoids by extending, not forking).
import { fortyYardAvgMph } from './fortyYardSpeed';
import { flyTenAvgMph } from './flyTenSpeed';

const DERIVED_MPH_FN_BY_TEST_TYPE = {
  forty_yard: fortyYardAvgMph,
  fly_ten: flyTenAvgMph,
};

/** MPH derived from a raw elapsed-time result, or null when this test
 * type has no derived speed (every test other than forty_yard/fly_ten)
 * or the value itself is missing/invalid. Never stored — always
 * recomputed from the raw attempt value at display time. */
export function derivedSpeedMph(testTypeKey, seconds) {
  const fn = DERIVED_MPH_FN_BY_TEST_TYPE[testTypeKey];
  return fn ? fn(seconds) : null;
}

/** Whether this test type has ANY derived speed at all — lets a caller
 * decide whether to render a "Speed" column/chip before it has a
 * specific value to show. */
export function hasDerivedSpeed(testTypeKey) {
  return Object.prototype.hasOwnProperty.call(DERIVED_MPH_FN_BY_TEST_TYPE, testTypeKey);
}
